module.exports = __webpack_public_path__ + "media/images/armoirie_and_text-7dad10a2f2e65716d9a05e19ee2874c9.png";